export { default as TabletNavigation } from './TabletNavigation';
